import { Button } from '../../../../cdl/Button/Button';
import { useDrawer } from '../../../../cdl/Drawer/useDrawer.hook';
import { useToasts } from '../../../../cdl/Toast/useToasts';
import { translate } from '../../../../common/helpers/translate.helper';
import { useRole } from '../../../../common/hooks/useRole';
import { IconSparkle } from '../../../../common/icons/cdl/Sparkle';
import { useApprovalRequestCreate } from '../../../../offer/MultipleApprovers/hooks/useMultipleApproversMutation';
import { OrderModel } from '../../../model/OrderModel';
import { OfferReviewDrawer } from '../../components/intelligence/OfferReviewDrawer';
import { useOrderOffers } from '../../hooks/useOrderOffers';

interface ReviewOffersButtonProps {
    order: OrderModel;
}

export const ReviewOffersButton = ({ order }: ReviewOffersButtonProps) => {
    const { push } = useDrawer();
    const role = useRole();
    const { addToast, addErrorToast } = useToasts();

    const offersQuery = useOrderOffers(order);
    const quotedOffers = offersQuery.data?.filter((offer) => offer.state === 'QUOTED') || [];
    const hasQuotedOffers = quotedOffers.length > 0;

    const approvalRequestCreateMutation = useApprovalRequestCreate();

    const handleRequestApproval = async (
        selectedApproverEmails: string[],
        message?: string,
        selectedOfferId?: string
    ): Promise<void> => {
        if (!selectedOfferId) return;

        try {
            await approvalRequestCreateMutation.mutateAsync({
                offerId: selectedOfferId,
                approvalRequestMessage: {
                    requestMessage: message,
                    approvers: selectedApproverEmails.map((emailAddress) => ({
                        emailAddress,
                    })),
                    offerId: selectedOfferId,
                    customerId: order.customerId,
                },
            });
            addToast(translate('closelinkInsights.offerReview.approvalRequestSent'));
        } catch {
            addErrorToast(translate('closelinkInsights.offerReview.approvalRequestError'));
        }
    };

    if (!hasQuotedOffers || !role.isCustomer() || !role.hasWriteRights(order.customerId)) {
        return null;
    }

    return (
        <Button
            type="button"
            LeadingIcon={IconSparkle}
            onClick={() =>
                push({
                    header: { title: translate('closelinkInsights.offerReview.title') },
                    content: <OfferReviewDrawer orderId={order.id} onRequestApproval={handleRequestApproval} />,
                })
            }
        >
            {quotedOffers.length === 1
                ? translate('closelinkInsights.reviewOffer')
                : translate('closelinkInsights.reviewOffers')}
        </Button>
    );
};
